<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="getRestaurantNetwork()" color="primary" id="store-number-search-button"
      [disabled]=!isMacAddressValid()>
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Mac Address</mat-label>
      <input matInput  type="string" maxlength="17" minLength="12" (keydown.enter)="!isMacAddressValid() ? $event.preventDefault() : getRestaurantNetwork()"
        [(ngModel)]="macAddressInput" autofocus/>
    </mat-form-field>
  </div>
</div>

@if (hasSearched && !newCradlepoint && !isLoading) {
  <div class="no-cradlepoint-found">
    <div class="alert alert-danger" >
      <p>No cradlepoint found with this MAC Address</p>
    </div>
  </div>
}
@if (configured) {
  <div class="success">
    <div class="alert alert-success" >
      <p>Cradlepoint successfully configured</p>
    </div>
  </div>
}
@if (error) {
  <div class="no-cradlepoint-found">
    <div class="alert alert-danger" >
      <p>{{ errorMessage }}
        <br> <strong>Current Values:</strong>
        <br> Store Number: {{ prevStoreNumber }}
          <br> Mac Address: {{ prevMacAddress }}
          </p>
        </div>
      </div>
    }
@if (timedOut) {
  <div class="no-cradlepoint-found">
    <div class="alert alert-warning" >
      <p>{{ errorMessage }}
        <br> <strong>Current Values:</strong>
        <br> Store Number: {{ prevStoreNumber }}
          <br> Mac Address: {{ prevMacAddress }}
          </p>
        </div>
      </div>
    }
    <div [cfaLoading]="isLoadingMain">
      @if (newCradlepoint) {
        <div class="container">
          <div class="cradlepoint-form-wrapper" >
            <app-cradlepoint-card [cradlepoint]="newCradlepoint"></app-cradlepoint-card>
          </div>
          <div id="add-cradlepoint-mat-card">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Update Configuration</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <mat-form-field appearance="outline">
                  <mat-label>Store Number</mat-label>
                  <input matInput type="text" inputmode="numeric" maxlength="5" (keydown.enter)="isSubmitDisabled() ? $event.preventDefault() : submit()" [(ngModel)]=storeNumberInput>
                  <mat-hint>Store is 5 digits long</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>MSP</mat-label>
                  <mat-select (selectionChange)="assignMsp($event.value)">
                    <mat-option value="Comcast">Comcast</mat-option>
                    <!-- <mat-option value="Lumen">Lumen</mat-option> -->
                    <mat-option value="HonorBuilt">HonorBuilt</mat-option>
                    <mat-option value="INTL">International</mat-option>
                  </mat-select>
                </mat-form-field>
                <button mat-raised-button (click)="submit()" color="primary" [disabled]="isSubmitDisabled()" class="icon-only-button">
                  <mat-icon>build</mat-icon>
                </button>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      }
    </div>
